/**
 * Backdrop-close handlers that only close the modal when BOTH the mouse
 * press and the release happen directly on the backdrop element.
 *
 * Why: the browser fires `click` on the nearest common ancestor of the
 * mousedown and mouseup targets. Dragging from an input (to select text)
 * and releasing outside the modal makes the backdrop the click target,
 * which closes the modal with a plain onClick={onClose} handler.
 *
 * Usage:
 *   <div className="my-modal-overlay" {...backdropCloseHandlers(onClose)}>
 *     <div className="my-modal-content">...</div>
 *   </div>
 *
 * Call it inline in render — each call returns an independent handler set.
 * If a re-render happens mid-gesture the state resets and the modal simply
 * stays open (fail-safe).
 */
export function backdropCloseHandlers(onClose) {
  let pressedOnBackdrop = false;
  let releasedOnBackdrop = false;
  return {
    onMouseDown(event) {
      pressedOnBackdrop = event.target === event.currentTarget;
    },
    onMouseUp(event) {
      releasedOnBackdrop = event.target === event.currentTarget;
    },
    onClick(event) {
      if (
        pressedOnBackdrop &&
        releasedOnBackdrop &&
        event.target === event.currentTarget
      ) {
        onClose?.(event);
      }
      pressedOnBackdrop = false;
      releasedOnBackdrop = false;
    },
  };
}

export default backdropCloseHandlers;
